import axios from "@/api/axiosInstance";
import { DownloadCampaignStatusCsvParams } from "./types";

export const downloadCampaignStatusCsv = async (
  params: DownloadCampaignStatusCsvParams,
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    `/api/private/stochastic/campaign-status/export/csv`,
    {
      params,
      responseType: "blob",
      headers: {
        Accept: "text/csv",
      },
    },
  );

  return response.data;
};
